import React from 'react';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import SearchInput from 'react-search-input';

import ContainerTranslation from "../partials/ContainerTranslation";
import Select from 'react-select';
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import _ from 'lodash';

const common = require('../../assets/translations/common.json');
const Range = Slider.Range;

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

class RexSearch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedStartDates : null,
      startDate : false,
      endDate : false,
      selectedEndDates : null
    }
  }

  componentDidUpdate(prevProps){
    if(this.state.selectedStartDates === null && this.state.selectedEndDates === null && this.props.dates){
      this.setState({
        selectedStartDates:[0,this.props.dates.length-1],
        selectedEndDates:[0,this.props.dates.length-1]
      })
      this.props.setSelectedStartDates([]);
      this.props.setSelectedEndDates([]);
    }
  }

  selectItem(parent, names, data) {
    var _this = this



    if(Array.isArray(data)){
      var dataToReturn = []
      

      if(names){
        _.each(names, function(name){
          dataToReturn.push({
            index: null,
            name: name,
            parent: parent,
            value: []
          });
        })
      }else{
        dataToReturn.push({
          index: null,
          name: null,
          parent: parent,
          value: []
        });
      }



      _.each(data, function(d){

        var foundData = _.find(dataToReturn, function(dr){

          if(d.name){
            return dr.name === d.name && dr.parent === d.parent
          }else{
            return dr.parent === d.parent
          }
        })

        if(foundData){
          foundData.value.push(d.value)
        }else{
          dataToReturn.push({
            index:undefined,
            name:d.name,
            parent:d.parent,
            value:[d.value]
          })
        }
      })
      _.each(dataToReturn, function(d){
        _this.props.selectItem(d);
      })
    }else{
      _this.props.selectItem(data);
    }
  }

  handleSortChange(data) {
    this.props.setSort(data.value);
  }

  handleStartDateChange(value) {
     this.setState({
       selectedStartDates:value
     })
  }

  handleStartDateAfterChange(value) {
     this.props.setSelectedStartDates([this.props.dates[value[0]], this.props.dates[value[1]]]);
  }

  toggleStartDate() {
    var _this = this
    if(_this.state.startDate){
      this.props.setSelectedStartDates([]);
    }else{
      this.props.setSelectedStartDates([this.props.dates[this.state.selectedStartDates[0]], this.props.dates[this.state.selectedStartDates[1]]]);
    }
    this.setState({
     startDate:!_this.state.startDate
    })
  }

  toggleEndDate() {
    var _this = this
    if(_this.state.endDate){
      this.props.setSelectedEndDates([]);
    }else{
      this.props.setSelectedEndDates([this.props.dates[this.state.selectedEndDates[0]], this.props.dates[this.state.selectedEndDates[1]]]);
    }
    this.setState({
     endDate:!_this.state.endDate
    })
  }

  handleEndDateChange(value) {
     this.setState({
       selectedEndDates:value
     })
  }

  handleEndDateAfterChange(value) {
     this.props.setSelectedEndDates([this.props.dates[value[0]], this.props.dates[value[1]]]);
  }

  handleValidationFilter(data) {
    this.props.selectValidationFilter(data.value);
  }

  render() {
    var _this = this
    var informationOptions = []
    var type;
    var informationData = ['program','projectManager']

    if(this.props.rexs){
      type = 'information'
      _.each(informationData, function(data){
        informationOptions.push({
          label: data,
          options: _.compact(_.uniqBy(_.compact(_.map(_this.props.rexs, function(rex){
            if(rex.aggregate[type][data]){
              return {
                value : rex.aggregate[type][data],
                label : rex.aggregate[type][data],
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
      })
    }


    var clientOptions = []

    var clientData = ["level_1"]
    if(this.props.rexs){
      type = 'client'
      _.each(clientData, function(data){
        clientOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(_this.props.rexs, function(rex){
            
            if(rex.aggregate[type].length > 0 && rex.aggregate[type][0][data]){
              return {
                value : rex.aggregate[type][0][data],
                label : rex.aggregate[type][0][data],
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
      })
    }

    var environnementOptions = []

    var environnementData = ['environnement-domain', 'environnement-context']
    if(this.props.rexs){
      type = 'environnement'
      _.each(environnementData, function(data){
        var options = []
        _.each(_this.props.rexs, function(rex){
          _.each(rex.aggregate[type + "." + data], function(d){
            options.push(d)
          })
        })

        environnementOptions.push({
          label: _this.props.translate("Filters-labels."+ [common.content[type][data].title[0]]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option){
              return {
                value : option,
                label : _this.props.translate(['context'] +"." + [option]),
                parent : type + "." + data
              }
            }
          })),'value'))
        })
      })
    }

    var expertiseOptions = []

    var expertiseData = ['domain-competence', 'domain-speciality', 'domain-specificity']
    if(this.props.rexs){
      type = 'expertise'
      _.each(expertiseData, function(data){
        var options = [];
        var category = common.content[type][data].title[0]
        _.each(_this.props.rexs, function(rex){
          _.each(rex.aggregate[type], function(item){
            if(item && item['domain-competence']){
              var obj = item
              obj.name  = item[data]
              if (category === "Technical competence") {
                obj.label = _this.props.translate(['domain-competence'] +"." + item['domain-competence'])
              }
              if (category === "Technical specialty") {
                obj.label = _this.props.translate(['domain-speciality'] +"." + item['domain-competence']+"." + item['domain-speciality'])
              }
              if (category === "Technical specificity") {
                obj.label = _this.props.translate(['domain-specificity'] +"." + item['domain-speciality'] +"." + item['domain-specificity'])
              }
              options.push(obj)
            }
          })
        })

        expertiseOptions.push({
          label: _this.props.translate(['domain-label']+"." + [category]),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
      })
    }

    var interventionLevelOptions = []

    var interventionLevelData = ['intervention-type', 'intervention-mission', 'intervention-application']
    if(this.props.rexs){
      type = 'intervention-level'
      _.each(interventionLevelData, function(data){
        var options = []
        var category  = common.content[type][data].title[0]
        _.each(_this.props.rexs, function(rex){
          _.each(rex.aggregate[type], function(item){
            var obj = item
            obj.name  = item[data]
            if (category === "Skill") {
              obj.label = _this.props.translate(['intervention-type'] +"." + item['intervention-type'])
            }
            if (category === "Mission") {
              obj.label = _this.props.translate(['intervention-mission'] +"." + item['intervention-type']+"." + item['intervention-mission'])
            }
            if (category === "Application") {
              obj.label = _this.props.translate(['intervention-application'] +"." + item['intervention-mission'] +"." + item['intervention-application'])
            }
            options.push(obj)
          })
        })

        interventionLevelOptions.push({
          label: _this.props.translate(['intervention-label']+ "." + category),
          options: _.compact(_.uniqBy(_.compact(_.map(options, function(option){
            if(option.name){
              return {
                value : option.name,
                label : option.label ? option.label : option.name,
                name : data,
                parent : type
              }
            }
          })),'value'))
        })
      })
    }


    let marksStart = {}
    let marksEnd = {}
    //Date
    if(this.state.selectedStartDates && this.props.dates && this.props.dates.length > 0){
      let startDate = this.state.selectedStartDates[0]
      let endDate = this.state.selectedStartDates[1]
      _.each(this.props.dates, function(time, i){
        if(i === startDate || i === endDate){
         return marksStart[i] = <span><strong>{time.dateLabel}</strong></span>
        }
      })
    }
    if(this.state.selectedEndDates && this.props.dates && this.props.dates.length > 0){
      let startDate = this.state.selectedEndDates[0]
      let endDate = this.state.selectedEndDates[1]
      _.each(this.props.dates, function(time, i){
        if(i === startDate || i === endDate){
         return marksEnd[i] = <span><strong>{time.dateLabel}</strong></span>
        }
      })
    }

    return (
      <div className="formulaires">
        <div className="formulaire-section" style={{width:'100%'}}>

          <div className="formulaire-header">
            <h2><ContainerTranslation id={'Filters'} /></h2><p className="info"><ContainerTranslation id={'Page.Project.Filters-info'} /></p>
          </div>

          <div className={"formulaire wide"}>
            <div className={"formulaire-field select"}>
              {/*INFORMATIONS*/}
              <div className={"inline"} style={{width:'calc(50% - 10px)'}}>
                <div className="input-container">
                  <label>
                    <ContainerTranslation id={"content."+['information']+".title"} tag={"span"}/>
                  </label>
                  <Select
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={informationOptions}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'information', informationData)}
                  />
                </div>
              </div>
              {/*CLIENT*/}
              <div className={"inline"} style={{width:'calc(50% - 10px)',marginLeft:'20px'}}>
                <label>
                  <ContainerTranslation id={"content."+['client']+".title"} tag={"span"}/>
                </label>
                <Select
                  className={'react-select-container'}
                  classNamePrefix="react-select"
                  options={clientOptions}
                  formatGroupLabel={formatGroupLabel}
                  isMulti={true}
                  placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                  onChange={this.selectItem.bind(this, 'client', clientData)}
                />
              </div>
            </div>

            <div className={"formulaire-field select"}>
              {/*INTERVENTION LEVEL*/}
              <div className={"inline"} style={{width:'calc(33.33% - 10px)'}}>
                <label>
                  <ContainerTranslation id={"content."+['intervention-level']+".title"} tag={"span"}/>
                </label>
                <Select
                  className={'react-select-container'}
                  classNamePrefix="react-select"
                  options={interventionLevelOptions}
                  formatGroupLabel={formatGroupLabel}
                  isMulti={true}
                  placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                  onChange={this.selectItem.bind(this, 'intervention-level', interventionLevelData)}
                />
              </div>
              {/*ENVIRONNEMENT*/}
              <div className={"inline"} style={{width:'calc(33.33% - 10px)',marginLeft:'15px'}}>
                <div className="input-container">
                  <label>
                    <ContainerTranslation id={"content."+['environnement']+".title"} tag={"span"}/>
                  </label>
                  <Select
                    className={'react-select-container'}
                    classNamePrefix="react-select"
                    options={environnementOptions}
                    formatGroupLabel={formatGroupLabel}
                    isMulti={true}
                    placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                    onChange={this.selectItem.bind(this, 'environnement', environnementData)}
                  />
                </div>
              </div>
              {/*EXPERTISE*/}
              <div className={"inline"} style={{width:'calc(33.33% - 10px)',marginLeft:'15px'}}>
                <label>
                  <ContainerTranslation id={"content."+['expertise']+".title"} tag={"span"}/>
                </label>
                <Select
                  className={'react-select-container'}
                  classNamePrefix="react-select"
                  options={expertiseOptions}
                  formatGroupLabel={formatGroupLabel}
                  isMulti={true}
                  placeholder={<ContainerTranslation id={'Placeholder-select'} />}
                  onChange={this.selectItem.bind(this, 'expertise', expertiseData)}
                />
              </div>
            </div>


            <div className={"formulaire-field select"}>

              {/*DATES*/}
              <div className={"inline"} style={{width:'calc(33.33% - 10px)',marginLeft:'15px', verticalAlign:'top'}}>

                  {this.state.selectedStartDates && this.props.dates && this.props.dates.length > 0 ? (
                    <div className="input-container">
                      <label style={{marginBottom:'10px', textDecoration:'underline', cursor:'pointer'}} onClick={this.toggleStartDate.bind(this)}>
                        <ContainerTranslation id={"content."+['information']+"."+['start-date']+".title"} tag={"span"}/>
                      </label>
                      <div style={{paddingLeft:'20px', paddingRight:'20px'}}>
                        <Range pushable
                          marks={marksStart}
                          disabled={!this.state.startDate}
                          trackStyle={[{ backgroundColor: '#eb4f1e' }]}
                          min={0} max={this.props.dates.length-1} step={1} defaultValue={[0, this.props.dates.length-1]}
                          onChange={this.handleStartDateChange.bind(this)}
                          onAfterChange={this.handleStartDateAfterChange.bind(this)}
                        />
                      </div>
                    </div>
                  ) : (
                  null
                  )}

              </div>

              <div className={"inline"} style={{width:'calc(33.33% - 10px)',marginLeft:'15px', verticalAlign:'top'}}>

                  {this.state.selectedEndDates && this.props.dates && this.props.dates.length > 0 ? (
                    <div className="input-container">
                      <label style={{marginBottom:'10px', textDecoration:'underline', cursor:'pointer'}} onClick={this.toggleEndDate.bind(this)}>
                        <ContainerTranslation id={"content."+['information']+"."+['end-date']+".title"} tag={"span"}/>
                      </label>
                      <div style={{paddingLeft:'20px', paddingRight:'20px'}}>
                        <Range pushable
                          marks={marksEnd}
                          disabled={!this.state.endDate}
                          trackStyle={[{ backgroundColor: '#eb4f1e' }]}
                          min={0} max={this.props.dates.length-1} step={1} defaultValue={[0, this.props.dates.length-1]}
                          onChange={this.handleEndDateChange.bind(this)}
                          onAfterChange={this.handleEndDateAfterChange.bind(this)}
                        />
                      </div>
                    </div>
                  ) : (
                  null
                  )}

              </div>

            </div>

          </div>

        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" , marginBottom: '10px', paddingLeft: '10px'}}>
          <div style={{position : "relative"}}>
            <div style={{height : "20px"}}></div>
          </div>
          <div style={{position : "relative"}}>
            <div style={{height : "20px"}}></div>
            <SearchInput className="search-input" placeholder={_this.props.translate('Placeholder-search')} onChange={this.props.searchUpdated} />
          </div>
          <div>
          <div style={{textAlign: 'left', display: 'inline-block', width:'150px', marginLeft:'10px'}}>
            <div>
              <ContainerTranslation id={'Validation status'} />
              <Select
                className={'react-select-container'}
                classNamePrefix="react-select"
                options={[
                  {
                    value:'all',
                    label:<ContainerTranslation id={'Validation.All'} />
                  },{
                    value:'validated',
                    label:<ContainerTranslation id={'Validation.Validated'} />
                  },{
                    value:'not validated',
                    label:<ContainerTranslation id={'Validation.Not Validated'} />
                  }
                ]}
                defaultValue={{
                  value:'all',
                  label:this.props.translate('Validation.All')
                }}
                formatGroupLabel={formatGroupLabel}
                isMulti={false}
                onChange={this.handleValidationFilter.bind(this)}
              />
            </div>
          </div>

            
            <div style={{textAlign: 'left', display: 'inline-block', width:'150px', marginLeft:'20px'}}>
                <ContainerTranslation id={'Sort By'} />
                  <Select
                  className={'react-select-container'}
                  classNamePrefix="react-select"
                  options={[
                    {
                      value:'alphabetic',
                      label: <ContainerTranslation id={'Sort.Alphabetic'} />
                    },{
                      value:'startDate',
                      label:<ContainerTranslation id={'Sort.' + ['Start Date']} />
                    },{
                      value:'duration',
                      label:<ContainerTranslation id={'Sort.Duration'} />
                    }
                    ,{
                      value:'completion',
                      label:<ContainerTranslation id={'Sort.Completion'} />
                    }
                  ]}
                  defaultValue={{
                    value:'alphabetic',
                    label: <ContainerTranslation id={'Sort.Alphabetic'} />
                  }}
                  formatGroupLabel={formatGroupLabel}
                  isMulti={false}
                  onChange={this.handleSortChange.bind(this)}
                />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps, {})(withLocalize(RexSearch));
